import axios from "../plugins/axios.plugin";

class BusinessVerificationService {
  baseServicePath = "/api/business-verification";

  getAllBusinessVerification() {
    return axios.get(`${this.baseServicePath}/me?properties=1`);
  }

  showABusinessVerification(user_id) {
    return axios.get(
      `${this.baseServicePath}/show?business_id=${user_id}&properties=1`
    );
  }

  showMyBusinessVerification() {
    console.log('fmkmf');

    return axios.get(`${this.baseServicePath}/me`);
  }

  editBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }

  filterBusinessVerification(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}`,
      payload
    );
  }

  storeBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }

  searchBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }

  verifyBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/verify`, payload);
  }

  rejectBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/reject`, payload);
  }
}

export const businessVerificationService = new BusinessVerificationService();
